import { render } from "./Nabvar_Bottom.vue?vue&type=template&id=f34d8082&scoped=true"
import script from "./Nabvar_Bottom.vue?vue&type=script&lang=js"
export * from "./Nabvar_Bottom.vue?vue&type=script&lang=js"

import "./Nabvar_Bottom.vue?vue&type=style&index=0&id=f34d8082&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f34d8082"]])

export default __exports__